// eslint-disable-next-line import/prefer-default-export
export const sidebar = state => state.sidebar;
